/* eslint-disable no-undef */
import $ from "jquery";

const hooksCart = () => {
  const init = () => {
    refreshAfterRefreshFragment();
  };

  const refreshAfterRefreshFragment = () => {
    jQuery(document.body).on("updated_cart_totals", function () {
      // window.location.reload();
      loadMiniCart();
    });
  };

  const loadMiniCart = () => {
    $.ajax({
      type: "POST",
      dataType: "json",
      url: themeObj.ajaxUrl,
      data: {
        action: themeObj.loadMiniCart.action,
        nonce: themeObj.loadMiniCart.nonce,
      },
      success(response) {
        const el = {
          counterEl: ".js-counter-cart",
          minicart: "#js-minicart",
        };

        const counter = response.data.count;
        const html = response.data.html;
        $(el.counterEl).text(counter);
        $(el.minicart).html(html);

        $(document.body).trigger("wc_fragment_refresh");
      },
      error(resp) {
        // eslint-disable-next-line no-console
        console.log(resp);
        // window.location.reload();
      },
      complete() {},
    });
  };

  init();
};

try {
  hooksCart();
} catch (error) {
  // eslint-disable-next-line no-console
  console.log(error);
}
